import { render } from "./PaymentMethods.vue?vue&type=template&id=4421ed4b&scoped=true"
const script = {}

import "./PaymentMethods.vue?vue&type=style&index=0&id=4421ed4b&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4421ed4b"]])

export default __exports__